// extracted by mini-css-extract-plugin
module.exports = {"toggleSwitch":"ToggleSwitch_toggleSwitch__agN-c","wrapper":"ToggleSwitch_wrapper__c7pjH","switch":"ToggleSwitch_switch__KNHtM","disabled":"ToggleSwitch_disabled__3O-GV"};